export interface LookupItem {
  id: number;
  code: string;
  name: string;
  node_type?: number;
}

export interface FilterLookups {
  starRatings: number[];
  categories: LookupItem[];
  accessModes: LookupItem[];
  paymentMethods: LookupItem[];
  payoutMethods: LookupItem[];
  amenities: LookupItem[];
}

export interface HotelFilters {
  priceRange: {
    min: number;
    max: number;
  };
  starRatings: number[];
  categories: string[];
  accessModes: string[];
  paymentMethods: string[];
  amenities: string[];
  searchText: string;
}

export const DEFAULT_FILTERS: HotelFilters = {
  priceRange: { min: 0, max: 10860 },
  starRatings: [],
  categories: [],
  accessModes: [],
  paymentMethods: [],
  amenities: [],
  searchText: "",
};
